jQuery( document ).ready( function( $ ) {
  // declare strict mode
  'use strict';

    asscript.menuControl = {
      button: $( '#uwa-menu-button' ),
      slide: $( 'nav .uwa-inner' ),
      clickHandler: function( e ) {
        if( asscript.menuControl.button.hasClass( 'uwa-menu-open' ) === false ) {
          asscript.menuControl.button.addClass( 'uwa-menu-open' ).removeClass( 'uwa-menu-close' );
          asscript.menuControl.slide.addClass( 'uwa-menu-slide-open' ).removeClass( 'uwa-menu-slide-close' );
          $( 'html' ).css( 'overflow', 'hidden' );
        } else {
          asscript.menuControl.button.removeClass( 'uwa-menu-open' ).addClass( 'uwa-menu-close' );
          asscript.menuControl.slide.addClass( 'uwa-menu-slide-close' ).removeClass( 'uwa-menu-slide-open' );
          $( 'html' ).css( 'overflow', 'auto');
        }
      },
      setClickHandler: function() {
        asscript.menuControl.button.on( 'click', asscript.menuControl.clickHandler );
      }
    };
    asscript.menuControl.setClickHandler();
} );
